import React from "react";
import logo from "../images/Logo LudoBlue.png";
import { Link } from "react-router-dom";

function Header(props) {
  

  return (
    
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <img
          src={logo}
          alt="Logo"
          width="5%"
          height="5%"
          className="d-inline-block align-text-top mt-1"
        />
      <div className="container-fluid  justify-content-center">
        
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-center" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link">
                Accueil
              </Link>
            </li>
            <li className="nav-item dropdown">
  <Link
    to="/LudoBlue"
    className="nav-link dropdown-toggle"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    LudoBlue
  </Link>
  <ul className="dropdown-menu">
    <li>
      <Link to="/LudoBlue#qui" className="dropdown-item">
        Qui sommes-nous ?
      </Link>
    </li>
    <li>
      <Link to="/LudoBlue#itinerance" className="dropdown-item">
        L’itinérance
      </Link>
    </li>
  </ul>
</li>


            <li className="nav-item dropdown">
              <Link
                to="/Animations"
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Les animations
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/Animations#tous" className="dropdown-item">
                    Temps de jeux pour tous
                  </Link>
                </li>
                <li>
                  <Link to="/Animations#grands-bois" className="dropdown-item">
                    Temps de grands jeux en bois
                  </Link>
                </li>
                <li>
                  <Link to="/Animations#cooperatifs" className="dropdown-item">
                    Temps de jeux coopératifs
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <Link
                to="/PretJeux"
                className="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                En savoir plus
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/PretJeux#tarifs" className="dropdown-item">
                    Nos tarifs et conditions
                  </Link>
                </li>
                <li>
                  <Link to="/PretJeux#comment-emprunter" className="dropdown-item">
                    Comment emprunter des jeux ?
                  </Link>
                </li>
                <li>
                  <Link to="/PretJeux#carte-cadeau" className="dropdown-item">
                    Offrez du jeu en cadeau !
                  </Link>
                </li>
                
              </ul>
            </li>
     
            <li className="nav-item">
              <Link to="/jeux" className="nav-link active" aria-current="page">
                Nos jeux 
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
                to="/demande"
                className="nav-link active"
                aria-current="page"
              >
                Demande d'animation
              </Link>
            </li> */}

            {/* <li className="nav-item">
              <Link
                to={"/login"}
                className="nav-link active"
                aria-current="page"
              >
                Utilisateur
              </Link>
            </li> */}
          </ul>
        </div>
        {/* <div className="navbar-text">{login}</div> */}
      </div>
      
    </nav>
  );
}

export default Header;
